<template>
    <div class="login">
        <div class="details hidden-xs hidden-sm"></div>

        <div class="login-container">
            <card>
                <div class="text-center">
                    <span class="lead">hello.</span>
                </div>

                <hr />

                <!-- Invalid credentials -->
                <transition name="slide-fade">
                    <div class="alert alert-danger" v-if="invalidLogin">
                        <strong>Invalid credentials</strong>. Please try again
                    </div>
                </transition>

                <form @keyup.enter="login">
                    <div class="form-group" :class="{'has-error': invalidLogin}">
                        <label>E-mail</label>
                        <input v-model="email" type="email" autocomplete="off" class="form-control">
                    </div>

                    <div class="form-group" :class="{'has-error': invalidLogin}">
                        <label>Password</label>
                        <input v-model="password" type="password" autocomplete="off" class="form-control">
                    </div>

                    <div class="text-center">
                        <button type="button" class="btn btn-primary btn-block" @click="login">Sign in</button>
                    </div>
                </form>

                <br />
            </card>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .login {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 15px 0;
        min-height: 100vh;

        .login-container {
            width: 350px;
            max-width: 100%;
        }

        label {
            color: #767676;
            font-weight: 400;
            font-size: 11px;
            text-transform: uppercase;
        }

        .form-group {
            padding-bottom: 10px;
        }

        &:after {
            content: " ";
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background: url('/static/images/wallpaper.jpg');
            background-size: cover;
            z-index: -3;
        }

        .details {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            z-index: -2;

            &:before {
                opacity: 0.1;
                position: absolute;

                top: 0;
                left: 0;

                content: " ";

                -webkit-transform: rotate(180deg);
                -moz-transform: rotate(180deg);
                -o-transform: rotate(180deg);
                -ms-transform: rotate(180deg);
                transform: rotate(180deg);

                width: 130%;
                height: 200px;

                background: url('/static/images/triangle.svg');
                background-repeat: no-repeat;
                background-size: cover;
                z-index: -1;
            }

            &:after {
                opacity: 0.05;
                position: absolute;

                bottom: 0;
                left: -50%;

                content: " ";

                width: 150%;
                height: 200px;

                background: url('/static/images/triangle.svg');
                background-repeat: no-repeat;
                background-size: cover;
                z-index: -1;
                padding-bottom: 100px;
            }
        }
    }
</style>

<script>
    import Loader from '@/components/layout/Loader'
    const authConfig = require('@/config/auth')
    const AuthService = require('@/services/auth/AuthService')
    import Card from '@/components/layout/Card'

    import {mapGetters, mapActions, mapMutations} from 'vuex'

    export default {
        data() {
            return {
                invalidLogin: false,
                email: null,
                password: null,
                hasLoaded: true
            }
        },

        mounted() {
            this.lookForStoredIdentity()
        },

        watch: {
            email() {
                this.invalidLogin = false;
            },

            password() {
                if (!this.hasLoaded) {
                    return;
                }

                this.invalidLogin = false;
            }
        },

        methods: {
            ...mapActions({
                setAccessToken: 'authSetAccessToken'
            }),

            /**
             * Look for a stored identity
             */
            lookForStoredIdentity() {
                const token = this.$localStorage.get('token')

                if (!token) {
                    return
                }

                this.setAccessToken({
                    token: token,
                    cb: () => {
                        this.$router.replace(this.$route.query.redirect || '/reservations')
                    }
                })
            },

            login() {
                // Show loader
                this.hasLoaded = false;

                AuthService.login(this.email, this.password, (response) => {
                    const body = response.data;
                    const bearerToken = body.access_token;

                    this.$localStorage.set('token', bearerToken);

                    this.setAccessToken({
                        token: bearerToken,
                        cb: () => {
                            this.$router.replace(this.$route.query.redirect || '/reservations')
                        }
                    });

                }, () => {
                    this.invalidCredentials()

                    setTimeout(() => {
                        this.hasLoaded = true
                    }, 200)
                });
            },

            invalidCredentials() {
                this.invalidLogin = true;
                this.password = '';
            }
        },

        components: {
            Card
        }
    }
</script>



// WEBPACK FOOTER //
// Login.vue?04a8d4fa